import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { CalendlyPop, getInitialRoute } from '../../../../../utils';
import { togglePlanSection_D } from '../../../../../actions/showDisplayModalAction';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
import { Button } from 'react-bootstrap';

function RevokeModal({ isFreePlan, show, setShow }) {
    const handleClose = () => setShow(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isOwner = localStorage.getItem('ownerId')
    const isCondition = ['138610'].includes(isOwner)
    const [talkshow, talksetShow] = useState(false);

    return (
        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size={'lg'} centered>
            <Modal.Body>
                <Button variant='' className="btn-close" onClick={handleClose}></Button>
                <div className="p-5 text-center">
                    <FontAwesomeIcon type={'solid'} icon={'triangle-exclamation'} iconClass={'text-danger display-1'} />
                    <h2 className="my-3 h3">{isFreePlan == 1 ? isCondition ? `Don’t Let Plan Limits Interrupt Your Event` : `You're accessing an unapproved network in your feed!` : `You're Running Extra ${getInitialRoute() != 'widget' ? 'Walls' : 'Widgets'}/Feeds!`}</h2>
                    <p className="mb-4">{isFreePlan == 1 ? isCondition ? `Our Social Walls experts can help you upgrade and unlock live engagement features built for events like yours.` : `To expand your options, we recommend you to upgrade your plan or delete the feeds to continue with your current plan.` : `To enjoy uninterrupted services,kindly revoke the additional wall/feed or upgrade your plan.`}</p>
                    <div className="text-center">
                        {isCondition ?
                            <>
                                <Button variant="primary" className={'me-4'} onClick={() => talksetShow(true)}>Talk to Sales</Button>
                                {talkshow && <CalendlyPop show={talkshow} hidePop={() => talksetShow(false)} url={'https://calendly.com/taggbox/csm?embed_domain=app.socialwalls.com&embed_type=PopupText'} />}</>
                            :
                            <Button variant='primary' className="me-4" onClick={() => { handleClose(); dispatch(togglePlanSection_D(true)) }}>Upgrade Now</Button>}
                        {!isCondition ? <Button variant='outline-dark' className="me-4 btn-min-w" onClick={handleClose}>Revoke</Button> : null}
                        <Button variant="primary" className="btn-min-w" onClick={() => {
                            localStorage.setItem('plan_exceeded', true); handleClose(); navigate(`/walls`);
                        }}>Skip</Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
export default RevokeModal;